'use strict';

import CollapseManager from "../../js/components/collapseManager";

export default class BrandReviewList extends HTMLElement {
    constructor() {
        super();
        this.brandReviewTemplate = document.querySelector('#brand-review-template');
        this.hotelReviewTemplate = document.querySelector('#hotel-review-template');
        this.backBtnTemplate = document.querySelector('#back-home-template');
        this.currentReviewsQuantity = parseInt(this.loadReviewsQuantity);
        this.featuredReviewId = parseInt(this.getAttribute('featured-review-id'));
            this.loadMoreAjaxData = {};
        if (this.getAttribute('review-filters')) {
            this.reviewFilters = document.querySelectorAll(this.getAttribute('review-filters'));
        }
        this.returnHomeUrl = this.getAttribute('return-home-url');
        this.moreReviewsUrl = this.getAttribute('more-reviews-url');
    }

    cloneBackBtn(){
        let backBtnElement = this.backBtnTemplate.content.cloneNode(true);
        this.instance.querySelector('#btn-home-reviews-container').appendChild(backBtnElement);
        this._fillElement(this.instance, 'return-home-btn', this.translationsJson.backBtnText);
        this.instance.querySelector('#btn-primary').href = this.returnHomeUrl;
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (this.shadowRoot) {
            this.instance = this.shadowRoot;
            if (name === 'review-list') {
                const brandReviewsInfo = JSON.parse(newValue);
                if (brandReviewsInfo['reviewsList']) {
                    this.brandReviewList = brandReviewsInfo['reviewsList'];
                    this.loadMoreAjaxData = brandReviewsInfo['params'] ? brandReviewsInfo['params'] : {};
                    this.instance.querySelector('[name="brand-review-list"]').innerHTML = "";
                    for (let brandReview of this.brandReviewList) {
                        this._buildReview(this.instance, brandReview);
                    }
                    this._createShowOriginalTextEvent(this.instance);
                    new CollapseManager(this._shadowRoot);
                }
            } else if (name === 'hide-show-more') {
                this._changeLoadMoreVisibility(this.instance, JSON.parse(newValue));
            }
        }
    }

    static get observedAttributes() {
        return ['review-list', 'translations', 'stylesheet', 'load-reviews-quantity', 'hide-show-more'];
    }

    connectedCallback() {
        this._shadowRoot = this.attachShadow({mode: 'open'});
        const t = document.querySelector('#brand-review-list-template');
        this.instance = t.content.cloneNode(true);
        this.brandReviewList = JSON.parse(this.reviewList);
        this.translationsJson = JSON.parse(this.translations);
        if (!this.stylesheet || !this.brandReviewList || this.brandReviewList.length === 0) {
            return;
        }
        this.instance.querySelector('[name="stylesheet"]').href = this.stylesheet;
        this._fillElement(this.instance, 'load-more-reviews-btn', this.translationsJson.loadMoreReviewsText);

        for (let brandReview of this.brandReviewList) {
            this._buildReview(this.instance, brandReview);
        }

        if (this.returnHomeUrl){
            this.cloneBackBtn();
        }

        this._eventDelegation();
        this._shadowRoot.appendChild(this.instance);
        new CollapseManager(this._shadowRoot);
    }

    _eventDelegation() {
        this.instance.querySelector('[data-action="load-more-reviews"]').addEventListener("click", this._loadMoreReviews.bind(this));
        this._createShowOriginalTextEvent(this.instance);
        this._registerFilterChangeEvents();
    }

    _createShowOriginalTextEvent(selector) {
        selector.querySelectorAll('[name="toggle-review-text-button"]:not([data-translate-click-listener])').forEach(elem => {
            elem.dataset.translateClickListener = true;
            elem.addEventListener('click', (event) => {
                const activeClass = 'active';
                const currentTarget = event.currentTarget;
                const reviewContainer = currentTarget.closest('.brand-review-container');
                const translatedTextViews = [
                    reviewContainer.querySelector('[name="brand-review-text"]'),
                    reviewContainer.querySelector('[name="brand-reply"]'),
                    ...reviewContainer.querySelectorAll('[name="hotel-review-text"]')
                ];
                const originalTextViews = [
                    reviewContainer.querySelector('[name="brand-review-text-original"]'),
                    reviewContainer.querySelector('[name="brand-reply-text-original"]'),
                    ...reviewContainer.querySelectorAll('[name="hotel-review-text-original"]')
                ];

                let translatedTextsAction = 'add';
                let originalTextsAction = 'remove';
                
                if (currentTarget.getAttribute('show-original-text') === 'false') {
                    // Mostramos los comentarios originales
                    translatedTextsAction = 'remove';
                    originalTextsAction = 'add';
                    currentTarget.setAttribute('show-original-text', 'true');
                    currentTarget.innerHTML = this.translationsJson.hideOriginalText;
                } else {
                    currentTarget.setAttribute('show-original-text', 'false');
                    currentTarget.innerHTML = this.translationsJson.showOriginalText;
                }

                translatedTextViews.forEach((view) => {
                    view.classList[translatedTextsAction](activeClass);
                });

                originalTextViews.forEach((view) => {
                    view.classList[originalTextsAction](activeClass);
                });
            });
        });
    }

    _buildReview(instance, brandReview) {
        let brandReviewElement = this.brandReviewTemplate.content.cloneNode(true);
        this._fillElement(brandReviewElement, 'user-initial', brandReview.user_alias.charAt(0));
        this._fillElement(brandReviewElement, 'user-alias', brandReview.user_alias);
        brandReviewElement.querySelector('[name="user-initial-container"]').classList.add('bg-'+brandReview.user_color);
        let languageFlag = brandReviewElement.querySelector('#language-flag');
        if (brandReview.translated_icon) {
            languageFlag.src = brandReview.translated_icon;
        }

        if (brandReview.id === this.featuredReviewId) {
            brandReviewElement.querySelector('[name="brand-review"]').classList.add('featured-review');
        }

        this._fillElement(brandReviewElement, 'traveler-type', brandReview.traveler_type);
        this._fillElement(brandReviewElement, 'travel-date', brandReview.travel_date);
        if (brandReview.would_return !== "") {
            this._fillElement(
                brandReviewElement,
                'would-book-again-text',
                brandReview.would_return == null ? this.translationsJson.notAnswer :
                    (brandReview.would_return ? this.translationsJson.wouldBookAgain : this.translationsJson.wouldNotBookAgain)
            );
            brandReviewElement.querySelector('[name="would-book-again"]').classList.remove('hidden');
        }
        let wouldBookAgainIconColor = brandReview.would_return == null ? 'color-secondary-medium' : (brandReview.would_return ? 'color-success' : 'color-danger');
        brandReviewElement.querySelector('#would-book-again-icon').classList.add(wouldBookAgainIconColor);
        this._fillElement(brandReviewElement, 'brand-review-text', brandReview.review);

        let showOriginalTextButton = brandReviewElement.querySelector('[name="toggle-review-text-button"]');
        if (brandReview.translated && brandReview.original_review) {
            showOriginalTextButton.classList.add('active');
            showOriginalTextButton.innerHTML = this.translationsJson.showOriginalText;
            this._fillElement(brandReviewElement, 'brand-review-text-original', brandReview.original_review);
        }

        if (brandReview.original_brand_reply && showOriginalTextButton.classList.contains('active')) {
            this._fillElement(brandReviewElement, 'brand-reply-text-original', brandReview.original_brand_reply);
        }

        if (brandReview.brand_reply) {
            this._fillElement(brandReviewElement, 'brand-name', this.translationsJson.brandName);
            this._fillElement(brandReviewElement, 'brand-reply', brandReview.brand_reply);
            brandReviewElement.querySelector('[name="brand-reply-container"]').classList.remove('hidden');
        }
        if (brandReview.hotel_review_rating > 0 && (brandReview.hotel_name || brandReview.hotel_review_positive ||
            brandReview.hotel_review_negative)) {
            this._fillElement(brandReviewElement, 'hotel-rating',
                this.translationsJson.hotelRatingText + " " + brandReview.hotel_review_rating);
            const hotelLink = brandReviewElement.querySelector('[data-entity="hotel-review-link"]');

            if (brandReview.hotel_url) {
                hotelLink.setAttribute('href', brandReview.hotel_url);
            }

            if (brandReview.hotel_name) {
                this._fillElement(brandReviewElement, 'hotel-name', brandReview.hotel_name);
                this._fillHotelCategory(brandReviewElement, 'star', brandReview.hotel_stars);
                this._fillHotelCategory(brandReviewElement, 'key', brandReview.hotel_keys);
                this._fillElement(brandReviewElement, 'hotel-city', brandReview.hotel_city);
            } else {
                brandReviewElement.querySelector('#hotel-link').remove();
            }
            if (brandReview.hotel_review_positive) {
                this._fillHotelReview(
                    brandReviewElement,
                    brandReview.hotel_review_positive,
                    brandReview.original_hotel_review_positive,
                    'ci-vector-up',
                    'color-gamma'
                );
            }
            if (brandReview.hotel_review_negative) {
                this._fillHotelReview(
                    brandReviewElement,
                    brandReview.hotel_review_negative,
                    brandReview.original_hotel_review_negative,
                    'ci-vector-down',
                    'color-danger'
                );
            }
        } else {
            let hotelRatingText = "";
            if (brandReview.hotel_review_rating > 0) {
                hotelRatingText = this.translationsJson.hotelRatingText + " " + brandReview.hotel_review_rating;
            } else {
                hotelRatingText = this.translationsJson.hotelNoRatingText;
            }
            this._fillElement(brandReviewElement, 'hotel-rating', hotelRatingText);
            const brandReviewCollapse = brandReviewElement.querySelector('[data-collapse-toggle="brand-review"]');
            brandReviewCollapse.removeChild(brandReviewCollapse.querySelector('[data-entity="arrow-down-icon"]'));
            brandReviewElement.querySelector('[data-entity="brand-review-footer"]').innerHTML = brandReviewCollapse.innerHTML;
        }

        instance.querySelector('[name="brand-review-list"]').appendChild(brandReviewElement);
    }

    _fillElement(instance, elementName, elementText) {
        let element = instance.querySelector('[name="' + elementName + '"]');
        if (element) {
            element.innerHTML = elementText;
        }
    }

    _fillHotelCategory(brandReviewElement, name, quantity) {
        if (quantity < 1) {
            return;
        }
        let hotelCategoryContainer = brandReviewElement.querySelector('[name="hotel-category"]');
        for (let i = 0; i < quantity; i++) {
            let category = document.createElement('i');
            category.classList.add('ci', 'ci-' + name, 'ci-s-13', 'color-category-light');
            hotelCategoryContainer.appendChild(category);
        }
    }

    _fillHotelReview(brandReviewElement, reviewText, originalReviewText, iconType, iconColor) {
        let hotelReviewElement = this.hotelReviewTemplate.content.cloneNode(true);
        this._fillElement(hotelReviewElement, 'hotel-review-text', reviewText);
        this._fillElement(hotelReviewElement, 'hotel-review-text-original', originalReviewText);
        hotelReviewElement.querySelector('#hotel-review-icon').classList.add(iconType, iconColor);
        brandReviewElement.querySelector('[name="hotel-review-container"]').appendChild(hotelReviewElement);
    }

    async _loadMoreReviews() {
        this._fillElement(this._shadowRoot, 'load-more-reviews-btn', this.translationsJson.loadingText);
        const optionsRequest = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.loadMoreAjaxData)
        }
        const reviewsListElement = this.shadowRoot.querySelector('[name="brand-review-list"]');
        this.currentReviewsQuantity = reviewsListElement.childElementCount;
        const responseReviews = await fetch(
            this.translationsJson.reviewsEndpointUrl + this.currentReviewsQuantity,
            optionsRequest
        );
        const dataReviews = await responseReviews.json();
        if (responseReviews.status === 200) {
            this._changeLoadMoreVisibility(this._shadowRoot, dataReviews.hideShowMore);
            if (dataReviews.data) {
                for (let brandReview of dataReviews.data) {
                    this._buildReview(this._shadowRoot, brandReview);
                }
                this.currentReviewsQuantity += dataReviews.data.length;
                this._fillElement(
                    this._shadowRoot,
                    'load-more-reviews-btn',
                    this.translationsJson.loadMoreReviewsText
                );
                this._createShowOriginalTextEvent(this.shadowRoot);
                new CollapseManager(this._shadowRoot);
            }
        }
    }

    _changeLoadMoreVisibility(instance, hideButton = false) {
        if (hideButton) {
            instance.querySelector('[name="load-more-reviews-btn"]').classList.add('hide');
        } else {
            instance.querySelector('[name="load-more-reviews-btn"]').classList.remove('hide');
        }
    }

    _registerFilterChangeEvents() {
        if (!this.reviewFilters) return;
        this.reviewFilters.forEach((reviewFilter) => {
            reviewFilter.addEventListener('change', (event) => {
                const data = {
                    'limit': 10,
                };
                this.reviewFilters.forEach((filter) => {
                    data[filter.getAttribute('data-type')] = filter.value;
                });

                fetch(this.moreReviewsUrl, {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }).then((r) => r.json()).then((response) => {
                    this.setAttribute('review-list', JSON.stringify({
                        'params': data,
                        'reviewsList': response.data
                    }));
                    this.setAttribute('hide-show-more', response.hideShowMore);
                    const reviewListEmptyContainer = document.querySelector('[data-entity="reviews-empty-alert"]').classList;
                    if (this.reviewListIsEmpty && reviewListEmptyContainer.contains('hidden')) {
                        reviewListEmptyContainer.remove('hidden');
                    } else if (!this.reviewListIsEmpty && !reviewListEmptyContainer.contains('hidden')) {
                        reviewListEmptyContainer.add('hidden');
                    }
                });
            });
        });
    }

    get reviewList() {
        return this.getAttribute('review-list');
    }

    get stylesheet() {
        return this.getAttribute('stylesheet');
    }

    get translations() {
        return this.getAttribute('translations');
    }

    get loadReviewsQuantity() {
        return this.getAttribute('load-reviews-quantity');
    }

    get reviewListIsEmpty() {
        return this.shadowRoot.querySelector('[name="brand-review-list"]').children.length === 0;
    }
}
